import React from 'react';
import { Link } from 'react-router-dom';

/**
 * DEP-LINK01: имя зависимого правила ведёт на его карточку. Контекст списка
 * (фильтры) живёт в URL, поэтому Back возвращает пользователя туда же.
 */
const RuleLink = ({ rule }) => {
  const label = rule?.name || rule?.rule_id || '—';
  if (!rule?.rule_id) return <span>{label}</span>;
  return <Link className="vio-rule-link" to={`/violations?tab=rules&ruleId=${encodeURIComponent(rule.rule_id)}`}>{label}</Link>;
};

export default RuleLink;
